<template>
  <div
      class="areal areal-container py-5"
  >
    <div class="text-center">
      <span class="h2">{{ floor.title }}</span>
    </div>

    <img
        id="map"
        :src="floor.image"
        usemap="#map"
        alt=""
        class="areal__img"
    />
    <map name="map">
      <area
          v-for="item in floor.apartments"
          :key="item.id"
          :coords="item.coords"
          :data-key="item.id + '-' + item.state_id"
          :href="item.link"
          shape="poly"
          @click.prevent="openExternalLink(item.link)"
          @mouseover="showPointer(item)"
          @mousemove="movePointer"
          @mouseleave="areaHover = false"
      />
    </map>

    <button-back/>

    <teleport to="body">
      <pointer
          v-if="areaHover"
          :data="areaHoverData"
          :posY="pointerPosY"
          :posX="pointerPosX"
      ></pointer>
    </teleport>
  </div>
</template>

<script>
import $ from "jquery";

import ButtonBack from "./ButtonBack.vue";

export default {
  props: ["floor"],
  components: {
    ButtonBack,
  },
  data() {
    return {
      areaHover: false,
      areaHoverData: null,
      pointerPosY: 0,
      pointerPosX: 0,
    };
  },

  methods: {
    openExternalLink(url) {
      window.open(url, "_blank").focus();
    },
    showPointer(item) {
      this.areaHoverData = item;
      this.areaHover = true;
    },
    movePointer(event) {
      if (this.areaHover) {
        let moveUp;
        let moveLeft;

        if (event.pageX > 900) {
          moveLeft = 450;
        } else {
          moveLeft = 100;
        }
        if (event.pageY < 200) {
          moveUp = 100;
        } else {
          moveUp = 200;
        }

        this.pointerPosY = event.pageY;
        this.pointerPosX = event.pageX;
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      let items = this.floor.apartments;

      function createAreas() {
        var output = [];

        // Pozemky
        for (let a = 0; a < items.length; a++) {
          output.push({
            fillColor: '525659',
            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: items[a].id + '-' + 4,
            selected: true,
          });
          output.push({
            fillColor: '598140',

            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: items[a].id + '-' + 3,
            selected: true,
          });
          output.push({
            fillColor: 'af4c0f',
            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: items[a].id + '-' + 2,
            selected: true,
          });
          output.push({
            fillColor: '525659',
            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: items[a].id + '-' + 1,
            selected: true,
          });
        }

        return output;
      }

      $("#map").mapster({
        fillColor: "62c141",
        fillOpacity: 0.8,
        clickNavigate: false,
        mapKey: "data-key",
        areas: createAreas(),
      });

      $(window).resize(function () {
        $("img[usemap]").each(function () {
          $(this).mapster(
              "resize",
              $(this).closest(".areal").width()
          );
        });
      });
    });
  },
};
</script>

<style lang="scss"
       scoped>
.areal {
  position: relative;

  &__img {
    width: 100%;
  }

  .h2 {
    color: #231E1E;
    font-size: 2.25rem;

    @media (max-width: 576px) {
      font-size: 1.75rem;
    }
  }

  &-container {
    margin: 0 auto;
    max-width: 900px;
  }
}
</style>
